import { SearchQueryForOptimize } from "../models";

export const searchQueryOptimizeRestrictions: Record<
  SearchQueryForOptimize,
  number
> = {
  rides: 3000,
  bookings: 50000,
  bookingsPassengers: 20000,
  reports: 30000,
};

export const NOTIFICATION_IMPORTANT_COUNT = 100;
export const RYDE_EVENTS_LIMIT = 1000;
export const GOOGLE_TILE_CREATE_SESSION_URL =
  "https://tile.googleapis.com/v1/createSession";
export const BAD_REQUEST_STATUS_CODE = 400;
